// useDocumentState.tsx
import * as React from "react";
import { propEq, find } from "ramda";
import { DocumentState } from "../components/DocumentProvider";
const {
  useEffect,
  useContext,
  useMemo
} = React;

const useDocumentState = name => {
  const ctx = useContext(DocumentState);
  const state = find(propEq("name", name), ctx);
  const value = state ? state.value : null;
  const setValue = state ? state.setComponentState : null;
  return [value, setValue];
};

export default useDocumentState;